import React from "react";
import NavItem from "./navItem";
import styles from "./style.module.css";

const Nav = ({ pages }) => {
  return (
    <nav className={styles.nav}>
      <ul className={styles.nav_list}>
        {pages.map(
          (page, index) => page.show_tab && <NavItem key={index} page={page} />
        )}
      </ul>
    </nav>
  );
};

export default Nav;
